<i
  class="cursor-pointer hover:text-gray-400 transition-colors"
  [ngClass]="icon()"
  [pTooltip]="tooltipText()"
  [escape]="false"
  [tooltipPosition]="tooltipPosition()"
  [tooltipOptions]="{showDelay: 150, hideDelay: 150}"
  [tooltipStyleClass]="tooltipStyleClassValue()"
></i>
